let  targetNode = document.querySelector('html')
  const sideCartCallback = function(mutationList){
      mutationList.forEach((mutation) => {
        let check=document.querySelector('.product-info__block product-form form .gokwik_btn button#gokwik-buy-now')?.innerText;
        let check2=document.querySelector(".select__select")?.value;
          mutation.addedNodes.forEach((added_node) => {
            if(check=="Sold Out" || check=="Unavailable"){
              $('#gokwik-buy-now').prop('disabled', true);
               $('#gokwik-buy-now').addClass('disabled');
            }else{
              $('#gokwik-buy-now').prop('disabled', false);
              $('#gokwik-buy-now').removeClass('disabled');
}
          })
      })
    // let couponNode = document.querySelector('.hs-code-text');


const cartButton = document.querySelector(".product-info__block product-form form .gokwik_btn button#gokwik-buy-now");
    const isDisabled = cartButton?.hasAttribute('disabled');
    
    const gkButton = document.querySelector("#gokwik-buy-now");
    if(isDisabled){
      if(gkButton){
        gkButton.style.opacity = '0.5';
        gkButton.style.pointerEvents = 'none';
      }
} 
    else {
      if(cartButton && gkButton){
           gkButton.style.opacity = '1';
         gkButton.style.pointerEvents = 'all';
      }
  
}
    
    }
   function setCookie(cName, cValue, expDays) {
    let date = new Date();
    cValue = encodeURIComponent(cValue)
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
const callback = function(mutationsList) {
    let couponNode = document.querySelector('.hs-code-text')
    mutationsList.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(added_node) {
          if(couponNode){
            let proCode = 'FIRSTPURCHASE10'
  if(proCode) setCookie('discount_code', proCode, 1);
          }
        });
      mutation.removedNodes.forEach(function(removed_node) {
        if(!couponNode){
            setCookie('discount_code', null, -1);
        }
        });
    });
};

     const config = { attributes: true, childList: true, subtree: true };
      const customBtn = new MutationObserver(sideCartCallback)
      customBtn.observe(targetNode, config)
  const observer = new MutationObserver(callback);
observer.observe(targetNode, config); 